import { render, staticRenderFns } from "./goods-item.vue?vue&type=template&id=52deec18&scoped=true"
import script from "./goods-item.vue?vue&type=script&lang=js"
export * from "./goods-item.vue?vue&type=script&lang=js"
import style0 from "./goods-item.vue?vue&type=style&index=0&id=52deec18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52deec18",
  null
  
)

export default component.exports